import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { BaseFormSubCadastro, BaseFormSubCadastroService } from '../../../../core';

import { CidadeSubRegiao } from '../cidade-sub-regiao';
import { CidadeSubRegiaoBairroComponent } from '../../bairro';
import { cidadeClassificacoes } from '../../classificacao-abc';


@Component({
    selector: 'sgt-cidade-sub-regiao-form',
    templateUrl: './cidade-sub-regiao-form.component.html'
})
export class CidadeSubRegiaoFormComponent implements BaseFormSubCadastro<CidadeSubRegiao> {
    entity: CidadeSubRegiao;
    entityIndex: number;
    editMode: boolean;
    @ViewChild('form') form: NgForm;
    classificacoes = cidadeClassificacoes;

    @Input() entities: CidadeSubRegiao[];
    @Input() isOpen: boolean;
    @Output() save = new EventEmitter<CidadeSubRegiao>();
    @Output() cancel = new EventEmitter<any>();

    @ViewChild('cidadeSubRegiaoBairroCadastro') cidadeSubRegiaoBairroCadastro: CidadeSubRegiaoBairroComponent;

    constructor(private baseFormSubCadastroService: BaseFormSubCadastroService) { }

    insert() {
        this.editMode = false;
        this.entity = new CidadeSubRegiao();
    }

    edit(index: number) {
        this.entityIndex = index;
        this.editMode = true;
        this.entity = this.baseFormSubCadastroService.prepareEdit(this.entityIndex, this.entities);
    }


    private beforeSave() {
        // Bairros
        this.cidadeSubRegiaoBairroCadastro.resolve();
    }

    onSave() {
        this.beforeSave();
        this.baseFormSubCadastroService.save(this.entity,
                                             this.entities,
                                             this.form,
                                             this.editMode,
                                             this.entityIndex,
                                             'Para salvar a sub-região é preciso informar corretamente todos os campos destacados em vermelho')
            .then(() => this.save.emit(this.entity))
            .catch(() => {});
    }

    onCancel() {
        this.cancel.emit();
    }
}
